/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "FeatureFlags": {
                    "fields": {
                      "flags": {
                        "type": ".squareup.sfs.external.models.FeatureFlags.Flag",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ValueType": {
                        "values": {
                          "VALUE_TYPE_DO_NOT_USE": 0,
                          "VALUE_TYPE_BOOLEAN": 1,
                          "VALUE_TYPE_INTEGER": 2
                        }
                      },
                      "Flag": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "value": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "intValue": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "valueType": {
                            "type": ".squareup.sfs.external.models.FeatureFlags.ValueType",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "VALUE_TYPE_BOOLEAN"
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.FeatureFlags && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.FeatureFlags?.nested?.ValueType && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.FeatureFlags?.nested?.Flag) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Feature flags to control the behavior of clients
 * --
 *
 * SOURCE FeatureFlags @ squareup/sfs/external/models/feature_flags.proto at 10:1
 */
export const FeatureFlags = $root.lookupType('squareup.sfs.external.models.FeatureFlags');
fixType(FeatureFlags);
Builder.createAndAttachToType(FeatureFlags);
/**
 * SOURCE ValueType @ squareup/sfs/external/models/feature_flags.proto at 11:3
 */
FeatureFlags.ValueType = $root.lookupEnum('squareup.sfs.external.models.FeatureFlags.ValueType').values;
/**
 * --
 * @desc A flag for an individual feature
 * --
 *
 * SOURCE Flag @ squareup/sfs/external/models/feature_flags.proto at 19:3
 */
FeatureFlags.Flag = $root.lookupType('squareup.sfs.external.models.FeatureFlags.Flag');
fixType(FeatureFlags.Flag, {
  name: {
    notEmpty: true
  },
  value: {
    required: true
  },
  valueType: {
    required: true
  }
});
Builder.createAndAttachToType(FeatureFlags.Flag);